"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

/** Campaign pages own their minimal chrome; the normal site is unchanged. */
export function SiteChrome({ children }: { children: ReactNode }) {
  return usePathname().startsWith("/lp/") ? null : children;
}
